module.exports = __webpack_public_path__ + "static/primarycompositeendpoint_chart_mobile_1-2fd53ad342f76c27acc3e149a2de5ccb.png";